import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "add-slide",
  style: {"display":"none"}
}
const _hoisted_2 = { class: "select-btn" }
const _hoisted_3 = ["id", "onMousedown"]
const _hoisted_4 = { class: "page-number" }

import { computed, ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore, useKeyboardStore } from '@/store'
import { fillDigit } from '@/utils/common'
import { ContextmenuItem } from '@/components/Contextmenu/types'
import useSlideHandler from '@/hooks/useSlideHandler'
import useScreening from '@/hooks/useScreening'
import useLoadSlides from '@/hooks/useLoadSlides'

import { SortableEvent } from 'sortablejs'
import Sortable from '@/components/Sortable.vue'
import ThumbnailSlide from '@/views/components/ThumbnailSlide/index.vue'
import LayoutPool from './LayoutPool.vue'
import { Popover } from 'ant-design-vue'

type ElementType = {
  index: number,
  itemHeight: number
}

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const mainStore = useMainStore()
const slidesStore = useSlidesStore()
const keyboardStore = useKeyboardStore()
const { selectedSlidesIndex: _selectedSlidesIndex, thumbnailsFocus } = storeToRefs(mainStore)
const { slides, slideIndex, slideExecEnd } = storeToRefs(slidesStore)
const { ctrlKeyState, shiftKeyState } = storeToRefs(keyboardStore)

const { slidesLoadLimit } = useLoadSlides()

const selectedSlidesIndex = computed(() => [..._selectedSlidesIndex.value, slideIndex.value])

const presetLayoutPopoverVisible = ref(false)

const thumbnailListRef = ref()
const humbnailItemRef = ref<HTMLElement | null>(null)
const {
  copySlide,
  pasteSlide,
  createSlide,
  createSlideByTemplate,
  copyAndPasteSlide,
  deleteSlide,
  cutSlide,
  selectAllSlide,
  sortSlides,
} = useSlideHandler()

// 切换页面
const changeSlideIndex = (index: number) => {
  mainStore.setActiveElementIdList([])

  if (slideIndex.value === index) return
  slidesStore.updateSlideIndex(index)
}

// 点击缩略图
const handleClickSlideThumbnail = (e: MouseEvent, index: number) => {
  const isMultiSelected = selectedSlidesIndex.value.length > 1

  if (isMultiSelected && selectedSlidesIndex.value.includes(index) && e.button !== 0) return

  // 按住Ctrl键，点选幻灯片，再次点击已选中的页面则取消选中
  if (ctrlKeyState.value) {
    if (slideIndex.value === index) {
      if (!isMultiSelected) return

      const newSelectedSlidesIndex = selectedSlidesIndex.value.filter(item => item !== index)
      mainStore.updateSelectedSlidesIndex(newSelectedSlidesIndex)
      changeSlideIndex(selectedSlidesIndex.value[0])
    }
    else {
      if (selectedSlidesIndex.value.includes(index)) {
        const newSelectedSlidesIndex = selectedSlidesIndex.value.filter(item => item !== index)
        mainStore.updateSelectedSlidesIndex(newSelectedSlidesIndex)
      }
      else {
        const newSelectedSlidesIndex = [...selectedSlidesIndex.value, index]
        mainStore.updateSelectedSlidesIndex(newSelectedSlidesIndex)
        changeSlideIndex(index)
      }
    }
  }
  // 按住Shift键，选择范围内的全部幻灯片
  else if (shiftKeyState.value) {
    if (slideIndex.value === index && !isMultiSelected) return

    let minIndex = Math.min(...selectedSlidesIndex.value)
    let maxIndex = index

    if (index < minIndex) {
      maxIndex = Math.max(...selectedSlidesIndex.value)
      minIndex = index
    }

    const newSelectedSlidesIndex = []
    for (let i = minIndex; i <= maxIndex; i++) newSelectedSlidesIndex.push(i)
    mainStore.updateSelectedSlidesIndex(newSelectedSlidesIndex)
    changeSlideIndex(index)
  }
  // 正常切换页面
  else {
    mainStore.updateSelectedSlidesIndex([])
    changeSlideIndex(index)
  }
}

// 设置缩略图工具栏聚焦状态（只有聚焦状态下，该部分的快捷键才能生效）
const setThumbnailsFocus = (focus: boolean) => {
  if (thumbnailsFocus.value === focus) return
  mainStore.setThumbnailsFocus(focus)

  if (!focus) mainStore.updateSelectedSlidesIndex([])
}

// 拖拽调整顺序后进行数据的同步
const handleDragEnd = (eventData: SortableEvent) => {
  // debugger
  const { newIndex, oldIndex } = eventData
  if (newIndex === undefined || oldIndex === undefined || newIndex === oldIndex) return
  sortSlides(newIndex, oldIndex)
}

const { enterScreening, enterScreeningFromStart } = useScreening()

const contextmenusThumbnails = (): ContextmenuItem[] => {
  return [
    {
      text: '粘贴',
      subText: 'Ctrl + V',
      handler: pasteSlide,
    },
    {
      text: '全选',
      subText: 'Ctrl + A',
      handler: selectAllSlide,
    },
    {
      text: '新建页面',
      subText: 'Enter',
      handler: createSlide,
    },
    {
      text: '幻灯片放映',
      subText: 'F5',
      handler: enterScreeningFromStart,
    },
  ]
}

const contextmenusThumbnailItem = (): ContextmenuItem[] => {
  return [
    {
      text: '剪切',
      subText: 'Ctrl + X',
      handler: cutSlide,
    },
    {
      text: '复制',
      subText: 'Ctrl + C',
      handler: copySlide,
    },
    {
      text: '粘贴',
      subText: 'Ctrl + V',
      handler: pasteSlide,
    },
    {
      text: '全选',
      subText: 'Ctrl + A',
      handler: selectAllSlide,
    },
    { divider: true },
    {
      text: '新建页面',
      subText: 'Enter',
      handler: createSlide,
    },
    {
      text: '复制页面',
      subText: 'Ctrl + D',
      handler: copyAndPasteSlide,
    },
    {
      text: '删除页面',
      subText: 'Delete',
      handler: () => deleteSlide(),
    },
    { divider: true },
    {
      text: '从当前放映',
      subText: 'Shift + F5',
      handler: enterScreening,
    },
  ]
}

// 处理左侧滚动条变化
watch(() => slideIndex.value, (newIndex) => {
  // console.log(slideExecEnd.value)
  if (slideExecEnd.value === true) {
    handleSelectIndex(newIndex)
    return
  }
  setTimeout(() => {
    handleSelectIndex(newIndex)
  }, 800)  
})
const handleSelectIndex = (value: number) => {
  if (thumbnailListRef.value) {
    const itemHeight = Math.round(humbnailItemRef.value?.clientHeight || 0)    
    const item = document.getElementById('thumbnail-item_' + value) 
    let itemRectY = 0
    if (item) {
      itemRectY = item.getBoundingClientRect().y
    }
    thumbnailListRef.value.scollVerticalTop({
      index: value,
      itemHeight,
      itemRectY
    })    
  }
 
}

return (_ctx: any,_cache: any) => {
  const _component_IconPlus = _resolveComponent("IconPlus")!
  const _component_IconDown = _resolveComponent("IconDown")!
  const _directive_contextmenu = _resolveDirective("contextmenu")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "thumbnails",
    onMousedown: _cache[3] || (_cache[3] = () => setThumbnailsFocus(true))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(createSlide)()))
      }, [
        _createVNode(_component_IconPlus, { class: "icon" }),
        _cache[4] || (_cache[4] = _createTextVNode("添加幻灯片"))
      ]),
      _createVNode(_unref(Popover), {
        trigger: "click",
        placement: "bottomLeft",
        visible: presetLayoutPopoverVisible.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((presetLayoutPopoverVisible).value = $event))
      }, {
        content: _withCtx(() => [
          _createVNode(LayoutPool, {
            onSelect: _cache[1] || (_cache[1] = slide => { _unref(createSlideByTemplate)(slide); presetLayoutPopoverVisible.value = false })
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_IconDown)
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _createVNode(Sortable, {
      ref_key: "thumbnailListRef",
      ref: thumbnailListRef,
      class: "thumbnail-list",
      list: _unref(slides),
      options: {
        animation: 200,
        scroll: true,
        scrollSensitivity: 50,
      },
      onEnd: handleDragEnd,
      itemKey: "id"
    }, {
      item: _withCtx(({ element, index }) => [
        _withDirectives((_openBlock(), _createElementBlock("div", {
          ref_key: "humbnailItemRef",
          ref: humbnailItemRef,
          id: 'thumbnail-item_'+ index,
          class: _normalizeClass(["thumbnail-item", {
            'active': _unref(slideIndex) === index,
            'selected': selectedSlidesIndex.value.includes(index),            
          }]),
          onMousedown: $event => handleClickSlideThumbnail($event, index)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["label", { 'offset-left': index >= 99 }])
          }, _toDisplayString(_unref(fillDigit)(index + 1, 2)), 3),
          _createVNode(ThumbnailSlide, {
            class: "thumbnail",
            slide: element,
            size: 210,
            visible: index < _unref(slidesLoadLimit)
          }, null, 8, ["slide", "visible"])
        ], 42, _hoisted_3)), [
          [_directive_contextmenu, contextmenusThumbnailItem]
        ])
      ]),
      _: 1
    }, 8, ["list"]),
    _createElementVNode("div", _hoisted_4, "幻灯片 " + _toDisplayString(_unref(slideIndex) + 1) + " / " + _toDisplayString(_unref(slides).length), 1)
  ], 32)), [
    [_directive_click_outside, () => setThumbnailsFocus(false)],
    [_directive_contextmenu, contextmenusThumbnails]
  ])
}
}

})